import { useMemo, useEffect } from 'react'
import { add, isAfter } from 'date-fns'

const STORAGE_KEY = 'carServerUnreachableAlertTargetDate'

/**
 * Hook that manages a persistent target date in localStorage.
 * The date persists across page refreshes and is only reset when expired.
 */
export const usePersistentDate = (minutesFromNow: number) => {
  const targetDate = useMemo(() => {
    // Read from localStorage on initial render
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const storedDate = new Date(stored)
      // Only use stored date if it's valid and still in the future
      if (!isNaN(storedDate.getTime()) && isAfter(storedDate, new Date())) {
        return storedDate
      }
    }
    // Create new target date and store it
    const newDate = add(new Date(), { minutes: minutesFromNow })
    localStorage.setItem(STORAGE_KEY, newDate.toISOString())
    return newDate
  }, [minutesFromNow])

  // Clear localStorage when countdown expires
  useEffect(() => {
    if (!isAfter(targetDate, new Date())) {
      localStorage.removeItem(STORAGE_KEY)
    }
  }, [targetDate])

  return targetDate
}
